export default __webpack_public_path__ + "e24a8df25304a2c9ed3154f2879ddc0b.png";